import { Reset } from "assets/icons/Common";
import { IconButtonInverted, Row } from "components/primitives";
import { useEffect, useState } from "react";
import styled from "styled-components";

const Noggle: React.FC = ({ state, setState, settings, pixelPosition }: any) => {
  const [reload, setReload] = useState(false);
  const [numbers, setNumbers] = useState<number[]>([]);

  const {
    grid,
    grid: { selectedColor, range },
  } = settings;

  const boxSize =
    Math.min(pixelPosition.width ?? 660, pixelPosition.height ?? 377) / grid.grid - 10;
  const fontSize = boxSize * 0.3;
  const padding = boxSize * 0.1;

  useEffect(() => {
    generateNumbers();
  }, [grid.grid, reload, range]);

  const generateNumbers = () => {
    const totalCells = grid.grid * grid.grid;
    const [min, max] = range;
    const generatedNumbers = Array.from(
      { length: totalCells },
      () => Math.floor(Math.random() * (max - min + 1)) + min,
    );
    setNumbers(generatedNumbers);
  };

  const onClickItem = (index: number) => {
    setState({ ...state, selectedIndex: index });
  };

  const reset = () => {
    setReload((prevState) => !prevState);
  };

  return (
    <OuterContainer>
      <GridContainer gridSize={grid.grid} boxSize={boxSize}>
        {numbers.map((number, index) => (
          <GridItem
            key={index}
            fontSize={fontSize}
            padding={padding}
            color={selectedColor}
            onClick={() => onClickItem(index)}
            gridSize={grid.grid}
            className="grid-item"
          >
            {number}
          </GridItem>
        ))}
      </GridContainer>
      <BottomBanner>
        <Row style={{ gap: 10 }}>
          <GoButton withShadow={false} Icon={Reset} onClick={reset} />
        </Row>
      </BottomBanner>
    </OuterContainer>
  );
};

const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
`;

const GridContainer = styled.div<{ gridSize: number; boxSize: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.gridSize}, 1fr);
  grid-template-rows: repeat(${(props) => props.gridSize}, 1fr);
  gap: 2cqw;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-items: center;
`;

const GridItem = styled.div<{
  fontSize: number;
  padding: number;
  color?: string;
  gridSize?: number;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.color ?? "#f0f0f0"};
  font-size: ${(props) => props.fontSize}px;
  font-weight: bold;
  padding: ${(props) => props.padding}px;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  box-shadow:
    inset 0.4cqw 0.4cqw 1.2cqw rgba(255, 255, 255, 0.1),
    inset -0.7cqw -1cqw 1cqw rgba(0, 0, 0, 0.3),
    rgba(0, 0, 0, 0.3) 0 0.4cqw 1cqw;
  border-radius: 2cqw;
`;

const Banner = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
`;

const BottomBanner = styled(Banner)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 0 var(--widget-border-radius) var(--widget-border-radius);
  height: 20cqh;
  width: 100%;
`;

const GoButton = styled(IconButtonInverted)`
  width: 10cqh;
  height: 10cqh;
`;

export default Noggle;
